<template>
  <right-panel :datas="connects" @onClose="onClose" ref="right-panel">
    <div slot="header">
      <translate>Setting WorkGroup</translate>
    </div>
    <div slot="content" class="wrapper-padding">
      <el-form :model="setting" :rules="rules" ref="workgropForm" label-width="110px">
        <el-form-item :label="attrText.name" prop="name">
           <el-input v-model.trim="setting.name"></el-input>
        </el-form-item>
        <el-form-item :label="attrText.desc" prop="desc">
           <!-- <el-input v-model.trim="setting.desc"></el-input> -->
           <el-input type="textarea" class="right-panel-textarea" v-model.trim="setting.desc"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="detail-btn">
      <el-button type="primary" @click="onSubmitForm()" :disabled="!setting.isCanSubmit">
        <translate>Submit</translate>
      </el-button>
      <el-button @click="$refs['right-panel'].onClose()">
        <translate>Cancel</translate>
      </el-button>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'WorkgroupSetting',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        setting: {
          name: '',
          desc: '',
          isCanSubmit: false
        },
        rules: {
          name: [
            {required: true, message: this.$gettext('Please input the workgroup name'), trigger: 'blur'},
            {min: 2, message: this.$gettext('2-255 characters'), trigger: 'change'},
            {max: 255, message: this.$gettext('2-255 characters'), trigger: 'change'}
          ],
          desc: [
            {max: 140, message: this.$gettext('length is within 140 characters'), trigger: 'change'}
          ]
        }
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    created () {
    },
    methods: {
      // 给seting赋值
      setVal (connects) {
        this.setting.name = connects.name
        this.setting.desc = connects.desc
      },
      // 提取翻译文本
      getTranslateText () {
        return {
          name: this.$gettext('Workgoup Name'),
          desc: this.$gettext('Describe')
        }
      },
      // 提交修改
      onSubmitForm () {
        this.$refs['workgropForm'].validate((valid) => {
          if (valid) {
            let params = {
              id: this.connects.id,
              data: {}
            }
            if (this.setting.name !== this.connects.name) {
              params.data.name = this.setting.name
            }
            if (this.setting.desc !== this.connects.desc) {
              params.data.desc = this.setting.desc
            }
            this.$store.dispatch(STORE_CONST.WORKGROUP.PATCH_WORKGROUP, params).then(() => {
              this.$notify({
                type: 'success',
                message: this.$gettext('Change successfully!')
              })
              this.$emit('callback')
            })
            this.$refs['right-panel'].onClose()
          } else {
            return false
          }
        })
      },
      // 关闭创建集群
      onClose () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
              this.setVal(this.connects)
            }, 300)
          } else {
            this.connects = this.items
            this.setVal(this.connects)
          }
        },
        deep: true
      },
      'setting': {
        handler: function (val) {
          if (this.connects && (this.setting.name !== this.connects.name || this.setting.desc !== this.connects.desc)) {
            this.setting.isCanSubmit = true
          } else {
            this.setting.isCanSubmit = false
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// workgroup-setting.vue?12f7b1f5